import { render, staticRenderFns } from "./LobbyStatus.vue?vue&type=template&id=50a1de8b"
import script from "./LobbyStatus.vue?vue&type=script&lang=js"
export * from "./LobbyStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports